import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import IcSystemChevronDown from "@traveloka/icon-kit-web/react/IcSystemChevronDown";
import { PropsWithChildren } from "react";
import {
  Animated,
  Pressable,
  StyleProp,
  StyleSheet,
  ViewStyle,
} from "react-native";
import BMView from "../../../../components/View/BMView";
import useCollapsibleAnimation from "../../../hooks/hooks";

type FormGroupWithLabelProps = {
  label?: string;
  accordion?:
    | {
        isOpen: boolean;
      }
    | boolean;
  style?: StyleProp<ViewStyle>;
};

type FormGroupDefaultProps = {
  style?: StyleProp<ViewStyle>;
};

type Props = FormGroupWithLabelProps | FormGroupDefaultProps;

export default function FormGroup(props: PropsWithChildren<Props>) {
  const { style, children } = props;
  const { label, accordion } =
    "label" in props ? props : { label: undefined, accordion: undefined };

  const {
    isOpen,
    contentAnimatedStyle,
    contentWrapperAnimatedStyle,
    chevronAnimatedStyle,
    onToggleAnimate,
    onLayoutContentWrapper,
  } = useCollapsibleAnimation({
    isAccordion: !!accordion,
    isDefaultOpen: typeof accordion === "object" ? accordion.isOpen : false,
  });

  return (
    <BMView
      spacing="lg"
      style={[
        styles.container,
        {
          overflow: isOpen ? "visible" : "hidden",
        },
        style,
      ]}
    >
      {label ? (
        <Pressable onPress={onToggleAnimate} disabled={!accordion}>
          <BMView row flex justify="between" align="center">
            <BMText variant="uiLargeEm">{label}</BMText>
            {accordion ? (
              <Animated.View style={chevronAnimatedStyle}>
                <IcSystemChevronDown />
              </Animated.View>
            ) : null}
          </BMView>
        </Pressable>
      ) : null}
      <Animated.View style={contentWrapperAnimatedStyle}>
        <Animated.View
          style={contentAnimatedStyle}
          onLayout={onLayoutContentWrapper}
          pointerEvents={isOpen ? "auto" : "none"}
        >
          <BMView spacing="lg">{children}</BMView>
        </Animated.View>
      </Animated.View>
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: BMPrimitives.BMSize.md,
    paddingVertical: BMPrimitives.BMSize.lg,
  },
});
